export const fileSizeValidator = (file: File, limit: number) => {
  // 轉換limit為byte
  limit = limit * 1024 * 1024;

  if (file.size > limit) {
    return false;
  }
  return true;
};
